import { useEffect, useState } from "react";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";
import TopicPicker from "@/components/TopicPicker";
import WebinarCard from "@/components/WebinarCard";

export default function WebinarsHub() {
  const { topic } = useApp();
  const [active, setActive] = useState(topic || "ai");
  const [webinar, setWebinar] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.nextWebinar(active).then((d) => setWebinar(d.available ? d.webinar : null)).finally(() => setLoading(false));
    api.logEvent("webinar.viewed", { topic: active });
  }, [active]);

  return (
    <div className="max-w-7xl mx-auto px-6 py-16" data-testid="webinars-hub">
      <div className="asf-overline mb-3">Live learning</div>
      <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight">Choose your topic</h1>
      <p className="text-slate-500 mt-3 max-w-xl">Tell us what you want to learn — we'll show you the single next best live webinar in your local time.</p>

      <div className="mt-8"><TopicPicker active={active} onSelect={setActive} /></div>

      <div className="mt-10">
        {loading ? (
          <div className="rounded-3xl bg-slate-100 h-56 animate-pulse" />
        ) : webinar ? (
          <WebinarCard webinar={webinar} />
        ) : (
          <div className="asf-card p-8 text-center">
            <p className="text-slate-600">New sessions are being scheduled. We'll notify you.</p>
          </div>
        )}
      </div>
    </div>
  );
}
